import { useCallback, useRef } from 'react';

export function useDebounce(handler, ms) {
    const timeoutId = useRef(null);
    
    return useCallback((...args) => {
        if (timeoutId.current != null) {
            clearTimeout(timeoutId.current);
        }

        timeoutId.current = setTimeout(() => {
            timeoutId.current = null;
            handler(...args);
        }, ms);
    }, [ handler, ms]);
}